export type CustomError = {
  message?: string;
  exceptionKey?: string;
  key?: string;
  errors?: Record<string, string>;
};

const parseError = (e: CustomError): string =>
  e.message ?? e.exceptionKey ?? e.key ?? "unexpectedError";

export default parseError;
